<template>
  <div style="background-color: white; width: 100%;">
    <div id="container" v-if="fullDataStructure">
      <div v-if="!showReport">
        <div id="sidebar" :class="[sidebarSizing == 'max' ? 'max-sidebar' : 'min-sidebar']">
          <div id="min-max-button-container">
            <button v-if="sidebarSizing == 'max'" @click="sidebarSizing = 'min'" class="secondary-gray-button-sm-global">
              &lt;
            </button>
            <button v-else @click="sidebarSizing = 'max'" class="secondary-gray-button-sm-global">
              >
            </button>
          </div>
          <div
            @click="switchQuestionIndex(-1);"
            :class="[
              currentQuestionIndex == -1 ? 'selected-question' : null,
              'questionNavBar'
            ]"
            style="text-align: center; font-weight: 700; font-size: 1.2rem"
          >
            <span v-if="sidebarSizing == 'max'">Introduction</span>
            <span v-else>I</span>
          </div>
          <div v-for="(item,index) in fullDataStructure.Questions" :key="index" 
            @click="switchQuestionIndex(index)"
            :class="[
              currentQuestionIndex == index ? 'selected-question' : null,
              'questionNavBar',
              determineScoreStyleClass(item)
            ]"
          >
            <span v-if="sidebarSizing == 'max'">{{ `${item.question}` }}</span>
            <span v-else>{{ index + 1 }}</span>
          </div>
          <div
            @click="switchQuestionIndex(fullDataStructure.Questions.length)"
            :class="[
              currentQuestionIndex == fullDataStructure.Questions.length ? 'selected-question' : null,
              'questionNavBar'
            ]"
            style="text-align: center; font-weight: 700; font-size: 1.2rem"
          >
            <span v-if="sidebarSizing == 'max'">Final Page</span>
            <span v-else>F</span>
          </div>
        </div>
        <div id="main-box">
          <div v-if="currentQuestionIndex < fullDataStructure.Questions.length && currentQuestionIndex >= 0" id="test-container">
            <div style="display: flex; flex-direction: column">
              <div id="question-title-container">
                <div>Question {{ currentQuestionIndex + 1 }}</div>
                <h2>{{ fullDataStructure.Questions[currentQuestionIndex].question }}</h2>
              </div>
              <div class="border-color-primary" id="preview-screen-specialist" :style="{position: 'relative'}">
                <div
                  v-for="(element, index2) in fullDataStructure.Questions[currentQuestionIndex].Elements" :key="`element-${index2}`"
                  :style="{
                    top: `${element.styles.top}px`,
                    left: ` ${element.styles.left}px`,
                    width: `${element.styles.width}px`,
                    height: `${element.styles.height}px`,
                    backgroundColor: element.styles.backgroundColor,
                    zIndex: element.styles.zIndex,
                    fontSize: `${element.styles.fontSize}px`,
                    position: 'absolute'
                  }"
                  class="resizable-button-container"
                >
                  <img v-if="element.image != ''" :src="`${reverseProxy}/api/${element.image}`" width="100%" height="100%">
                  <div class="placeholder-rect">{{ element.content }}</div>
                </div>
              </div>
            </div>
            <div>
              <div id="timing-container">
                <div>
                  <div class="grey-800-text">00:00:00</div>
                  <div class="grey-700-text">Time on question</div>
                  <div>
                    <small>
                      <span class="grey-800-text">Typical time: </span>
                      <span class="grey-700-text">{{ fullDataStructure.Questions[currentQuestionIndex].typical_duration }}</span>
                    </small>
                  </div>
                  <div>
                    <small>
                      <span class="grey-800-text">Typical limit: </span>
                      <span class="grey-700-text">{{ fullDataStructure.Questions[currentQuestionIndex].time_out }}</span>
                    </small>
                  </div>
                </div>
                <button @click="openUpChildView" class="secondary-color-button-sm-global" style="width: 100%; margin-top: 1rem;">
                  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.75 16.2031L15.75 7.20312" stroke="#B46909" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.75 7.20312H15.75V16.2031" stroke="#B46909" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Child View
                </button>
              </div>
            </div>
            <div>
              <div>
                <div class="answer-card">
                  <span class="score-number score-incorrect">0</span> Incorrect
                </div>
                <div v-for="n in fullDataStructure.Questions[currentQuestionIndex].highest_score_possible" :key="n" class="answer-card">
                  <div @click="scoreQuestion(fullDataStructure.Questions[currentQuestionIndex], n)">
                    <span class="score-number score-correct">{{ `+${n}` }}</span> Correct
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button @click="switchQuestionIndex(currentQuestionIndex - 1);" class="secondary-gray-button-sm-global">&lt;</button>
              <div id="icons-container">
                <button class="secondary-gray-button-sm-global">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <small>Camera</small>
                </button>
                <button class="secondary-gray-button-sm-global">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1C11.2044 1 10.4413 1.31607 9.87868 1.87868C9.31607 2.44129 9 3.20435 9 4V12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12V4C15 3.20435 14.6839 2.44129 14.1213 1.87868C13.5587 1.31607 12.7956 1 12 1Z" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19 10V12C19 13.8565 18.2625 15.637 16.9497 16.9497C15.637 18.2625 13.8565 19 12 19C10.1435 19 8.36301 18.2625 7.05025 16.9497C5.7375 15.637 5 13.8565 5 12V10" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 19V23" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 23H16" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <small>Recorder</small>
                </button>
                <button class="secondary-gray-button-sm-global">
                  <svg viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.33301 3.7513C4.33301 3.46398 4.44714 3.18843 4.65031 2.98527C4.85347 2.78211 5.12902 2.66797 5.41634 2.66797H16.2497L21.6663 8.08464V23.2513C21.6663 23.5386 21.5522 23.8142 21.349 24.0173C21.1459 24.2205 20.8703 24.3346 20.583 24.3346H5.41634C5.12902 24.3346 4.85347 24.2205 4.65031 24.0173C4.44714 23.8142 4.33301 23.5386 4.33301 23.2513V3.7513Z" stroke="#696969" stroke-width="1.57576" stroke-linejoin="round"/>
                    <path d="M8.66602 11.3359H17.3327M8.66602 15.6693H17.3327" stroke="#696969" stroke-width="1.57576" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <small>Notes</small>
                </button>
                <button class="secondary-gray-button-sm-global">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 1.28906V22.7091L5.737 17.4991H1V6.49906H5.737L15 1.28906ZM4.999 8.49906H3V15.4991H4.999V8.49906ZM6.999 15.9141L13 19.2891V4.70906L6.999 8.08306V15.9141ZM20.979 6.98106L21.582 7.77906C22.4998 8.99464 22.9961 10.4764 22.9956 11.9996C22.995 13.5227 22.4977 15.0041 21.579 16.2191L20.976 17.0171L19.381 15.8111L19.984 15.0131C20.6405 14.1451 20.9959 13.0867 20.9963 11.9984C20.9967 10.9101 20.6419 9.85144 19.986 8.98306L19.383 8.18606L20.979 6.98106ZM18.186 9.08906L18.789 9.88706C19.248 10.4948 19.4962 11.2357 19.496 11.9972C19.4958 12.7588 19.2473 13.4995 18.788 14.1071L18.184 14.9051L16.59 13.6991L17.193 12.9021C17.39 12.6417 17.4967 12.3242 17.4969 11.9977C17.4971 11.6712 17.3907 11.3536 17.194 11.0931L16.591 10.2951L18.186 9.08906Z" fill="#696969"/>
                  </svg>
                  <small>Audio Instructions</small>
                </button>
                <button class="secondary-gray-button-sm-global">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0247 15.6413C20.7423 14.6337 21.1343 13.4346 21.1343 12.1728C21.1343 10.8972 20.733 9.68555 20 8.6715V3H2V17H10V20H5.99998V22H16V20H12V17.2717C12.9593 17.8608 14.0439 18.1699 15.1343 18.1699C16.3546 18.1699 17.5665 17.7852 18.6028 17.0477L21.0088 19.4336L22.417 18.0137L20.0247 15.6413ZM9.83938 15H4.00002V5.00002H18V6.9008C17.1305 6.42652 16.1524 6.17283 15.1348 6.17283C13.5317 6.17283 12.0254 6.79687 10.8921 7.93064C9.7588 9.06347 9.13475 10.5703 9.13475 12.1728C9.13475 13.1753 9.37902 14.1404 9.83938 15ZM17.9629 15.002C16.4043 16.5615 13.8667 16.5615 12.3062 15.002C11.5508 14.2461 11.1348 13.2412 11.1348 12.1728C11.1348 11.1045 11.5508 10.1006 12.3062 9.34472C13.062 8.58886 14.0664 8.17284 15.1348 8.17284C16.2026 8.17284 17.207 8.58886 17.9629 9.34472C18.7183 10.1006 19.1343 11.1045 19.1343 12.1728C19.1343 13.2412 18.7183 14.2461 17.9629 15.002" fill="#696969"/>
                  </svg>
                  <small>Tracking</small>
                </button>
                <button class="secondary-gray-button-sm-global">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.7494C10.6332 2.74966 9.29871 3.16484 8.17301 3.94002C7.04731 4.71519 6.18345 5.81385 5.69571 7.09064C5.20797 8.36744 5.11932 9.76223 5.4415 11.0905C5.76368 12.4188 6.4815 13.6179 7.50001 14.5294L7.50301 14.5334C8.06001 15.0324 8.48301 15.4104 8.78501 15.6884C9.07001 15.9484 9.29501 16.1624 9.41401 16.3084L9.42601 16.3234C9.64801 16.5964 9.84001 16.8344 9.96801 17.1194C10.095 17.4034 10.143 17.7064 10.199 18.0534L10.202 18.0734C10.231 18.2514 10.242 18.4694 10.247 18.7494H13.753C13.758 18.4694 13.769 18.2514 13.798 18.0734L13.801 18.0534C13.857 17.7064 13.905 17.4034 14.032 17.1194C14.16 16.8344 14.352 16.5964 14.574 16.3234L14.586 16.3084C14.705 16.1624 14.93 15.9484 15.215 15.6884C15.517 15.4104 15.94 15.0324 16.497 14.5334L16.501 14.5294C17.5196 13.6179 18.2374 12.4186 18.5596 11.0903C18.8817 9.76189 18.793 8.36702 18.3051 7.09018C17.8173 5.81334 16.9532 4.71469 15.8274 3.93959C14.7015 3.16449 13.3669 2.74946 12 2.7494ZM13.744 20.2494H10.256C10.26 20.3527 10.2653 20.4451 10.272 20.5264C10.292 20.7514 10.327 20.8334 10.351 20.8744C10.4168 20.9882 10.5112 21.0826 10.625 21.1484C10.665 21.1724 10.748 21.2064 10.973 21.2274C11.208 21.2484 11.519 21.2494 12 21.2494C12.481 21.2494 12.792 21.2494 13.027 21.2274C13.252 21.2074 13.334 21.1724 13.375 21.1484C13.4888 21.0826 13.5833 20.9882 13.649 20.8744C13.673 20.8344 13.708 20.7514 13.728 20.5264C13.7347 20.4451 13.74 20.3527 13.744 20.2494ZM3.75001 9.4994C3.75011 8.12339 4.09438 6.76925 4.75149 5.56027C5.40859 4.3513 6.35766 3.32588 7.51228 2.57737C8.6669 1.82887 9.99041 1.38105 11.3623 1.27469C12.7342 1.16832 14.1109 1.4068 15.3671 1.96839C16.6233 2.52999 17.7191 3.39687 18.5547 4.49012C19.3903 5.58337 19.9391 6.86826 20.1513 8.22781C20.3635 9.58737 20.2323 10.9784 19.7696 12.2743C19.3068 13.5702 18.5273 14.7297 17.502 15.6474C17.0754 16.0272 16.6507 16.4092 16.228 16.7934C16.0787 16.9306 15.932 17.0706 15.788 17.2134L15.752 17.2524C15.492 17.5734 15.435 17.6564 15.402 17.7314C15.368 17.8064 15.344 17.9034 15.279 18.3114C15.253 18.4724 15.25 18.7484 15.25 19.4994V19.5314C15.25 19.9714 15.25 20.3514 15.222 20.6614C15.192 20.9914 15.126 21.3174 14.949 21.6244C14.7515 21.9667 14.4673 22.2509 14.125 22.4484C13.818 22.6254 13.492 22.6914 13.163 22.7214C12.851 22.7494 12.472 22.7494 12.033 22.7494H11.968C11.528 22.7494 11.148 22.7494 10.838 22.7214C10.508 22.6914 10.182 22.6254 9.87501 22.4484C9.53274 22.2509 9.24854 21.9667 9.05101 21.6244C8.87401 21.3174 8.80801 20.9914 8.77801 20.6624C8.75001 20.3504 8.75001 19.9714 8.75001 19.5324V19.4994C8.75001 18.7494 8.74701 18.4724 8.72101 18.3114C8.65601 17.9034 8.63101 17.8064 8.59801 17.7314C8.56501 17.6564 8.50801 17.5734 8.24801 17.2514L8.23801 17.2414L8.21201 17.2124L8.11501 17.1154C8.00216 17.0065 7.88782 16.8991 7.77201 16.7934C7.47701 16.5234 7.06001 16.1504 6.49801 15.6474C5.63236 14.8743 4.94001 13.9269 4.4664 12.8673C3.9928 11.8078 3.74866 10.66 3.75001 9.4994ZM9.89201 13.3494C9.97729 13.3001 10.0715 13.268 10.1691 13.2551C10.2668 13.2421 10.3661 13.2486 10.4613 13.274C10.5565 13.2995 10.6457 13.3434 10.7239 13.4034C10.8021 13.4633 10.8677 13.5381 10.917 13.6234C11.0267 13.8136 11.1845 13.9716 11.3746 14.0815C11.5647 14.1914 11.7804 14.2492 12 14.2492C12.2196 14.2492 12.4353 14.1914 12.6254 14.0815C12.8155 13.9716 12.9734 13.8136 13.083 13.6234C13.1324 13.5381 13.1981 13.4634 13.2763 13.4035C13.3546 13.3436 13.4439 13.2997 13.5391 13.2743C13.6343 13.2489 13.7336 13.2425 13.8313 13.2555C13.929 13.2684 14.0232 13.3005 14.1085 13.3499C14.1938 13.3993 14.2685 13.465 14.3284 13.5432C14.3883 13.6215 14.4322 13.7108 14.4576 13.806C14.483 13.9012 14.4894 14.0005 14.4765 14.0982C14.4635 14.1959 14.4314 14.2901 14.382 14.3754C14.0231 14.9942 13.438 15.4496 12.75 15.6454V16.9994C12.75 17.1983 12.671 17.3891 12.5303 17.5297C12.3897 17.6704 12.1989 17.7494 12 17.7494C11.8011 17.7494 11.6103 17.6704 11.4697 17.5297C11.329 17.3891 11.25 17.1983 11.25 16.9994V15.6454C10.562 15.4496 9.97687 14.9942 9.61801 14.3754C9.56866 14.2901 9.53661 14.1959 9.52368 14.0983C9.51074 14.0006 9.51718 13.9013 9.54263 13.8061C9.56807 13.7109 9.61203 13.6217 9.67197 13.5435C9.73192 13.4653 9.80669 13.3987 9.89201 13.3494Z" fill="#696969"/>
                  </svg>
                  <small>Prompts</small>
                </button>
              </div>
              <button @click="switchQuestionIndex(currentQuestionIndex + 1);" class="primary-button-sm-global">></button>
            </div>
          </div>
          <div v-else-if="currentQuestionIndex < 0" id="intro-container">
            <div id="intro-box">
              <img v-if="fullDataStructure.image" :src="`${reverseProxy}/api/${fullDataStructure.image}`" alt="Picture N/A" loading="lazy"/>
              <h1>{{ fullDataStructure.title }}</h1>
              <div id="intro-grid">
                <div>Child/Patient</div>
                <div>John Doe</div>
                <div>Number of Questions</div>
                <div>{{ fullDataStructure.Questions.length }}</div>
                <div>Start Time:</div>
                <div>03/04/2025, 3:11 PM</div>
                <div>App ID</div>
                <div>SK33RW9EG</div>
              </div>
              <button @click="switchQuestionIndex(0)" style="margin-right: 1rem; width: 100%;" class="primary-button-sm-global">Start Activity</button>
            </div>
          </div>
          <div v-else id="finish-box">
            <div>
              <h5>Final Results</h5>
              <p>Congrats on completing the application! Here are your results:</p>
              <div id="final-result-box">
                Question Result
                <ul>
                  <li v-for="(item,index) in fullDataStructure.Questions" :key="index" :class="assignColor(index)">
                    <span>{{ `Q${index+1} ${fullDataStructure.Questions[index].question}` }}</span>
                    <span v-if="randomScores[index] == 0" class="incorrect-box">
                      Incorrect
                    </span>
                    <span v-else class="correct-box">
                      Correct
                    </span>
                  </li>
                </ul>
              </div>
              <div style="display: flex; justify-content: center; margin-top: 1rem;">
                <button class="primary-button-sm-global" @click="showReportToggle">Continue to Final Report</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <ConfigureReportNewApp :applicationID="applicationID" @backToAppConfig="backToAppConfig"/>
      </div>
    </div>
  </div>
</template>

<script>
  import instance from '../axios';
  import ConfigureReportNewApp from './subComponents/ConfigureReportNewApp.vue';

  export default {
    components:{
      ConfigureReportNewApp
    },
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        fullDataStructure: null,
        applicationID: null,
        applicationInfo: null,
        currentQuestionIndex: -1,
        showReport: false,
        sidebarSizing: 'min',
        randomScores: [],

        specialistChannelOpen: false,
        channel: null,
      }
    },
    async created() {
      try {
        this.applicationID = this.$route.params.applicationID;
        let fullDataStructureResponse = await instance.get(`/api/appAdmin/application/structure/${this.applicationID}`);
        this.fullDataStructure = fullDataStructureResponse.data;
        this.fullDataStructure.Questions.sort((a, b) => a.question_order - b.question_order);

        for (let i = 0; i < this.fullDataStructure.Questions.length; i++) {
          //parse the score points into usuable strings
          //add temperary variables for functionality
          this.fullDataStructure.Questions[i].specialist_buttons = JSON.parse(this.fullDataStructure.Questions[i].specialist_buttons);
/*             this.fullDataStructure.Questions[i].time_out = this.intervalToSeconds(this.fullDataStructure.Questions[i].time_out);
          this.fullDataStructure.Questions[i].typical_duration = this.intervalToSeconds(this.fullDataStructure.Questions[i].typical_duration); */
          this.fullDataStructure.Questions[i].typicalDurationTimer = null;
          this.fullDataStructure.Questions[i].timeOutTimer = null;
          this.fullDataStructure.Questions[i].questionDuration = null;
          this.fullDataStructure.Questions[i].typicalDurationTimerElapsedTime = this.intervalToSeconds(this.fullDataStructure.Questions[i].typical_duration);
          this.fullDataStructure.Questions[i].timeOutTimerElapsedTime = this.intervalToSeconds(this.fullDataStructure.Questions[i].time_out);
          this.fullDataStructure.Questions[i].questionDurationTimerElapse = 0;

          for (let j = 0; j < this.fullDataStructure.Questions[i].Elements.length; j++) {
            this.fullDataStructure.Questions[i].Elements[j].styles = JSON.parse(this.fullDataStructure.Questions[i].Elements[j].styles)
            this.fullDataStructure.Questions[i].Elements[j].events_actions = JSON.parse(this.fullDataStructure.Questions[i].Elements[j].events_actions)
          }

          this.randomScores.push(this.getRandomScore(i));
        }
      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      switchQuestionIndex(index) {
        this.currentQuestionIndex = index;
        if (this.channel) {
          this.sendChannelMessage({
            action: 'changeIndex',
            data: index
          });
        }
        if (index < this.fullDataStructure.Questions.length && index >= 0) {
          this.formatForNewResolution('preview-screen-specialist');
        }
      },
      assignColor(index) {
        const max = parseInt(this.randomScores[index], 10);
        if (max === 0) {
          return 'score-zero';
        } else {
          return 'score-greenFull';
        }
      },
      getRandomScore(index) {
        const max = parseInt(this.fullDataStructure.Questions[index].highest_score_possible, 10);
        return Math.floor(Math.random() * (max + 1));
      },
      showReportToggle() {
        this.showReport = !this.showReport;
      },
      backToAppConfig() {
        this.showReportToggle();
      },
      secondsToInterval(seconds) {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return `${h}:${m}:${s}`;
      },
      intervalToSeconds(interval) {
        const [h, m, s] = interval.split(":").map(Number);
        return h * 3600 + m * 60 + s;
      },
      getImageFileSrc(imageDetailObject) {
        if (imageDetailObject.fileRef != null && imageDetailObject.fileRef != "") {
          return imageDetailObject.fileRef;
        } else if (imageDetailObject.file != null) {
          return URL.createObjectURL(imageDetailObject.file);
        } else {
          return null;
        }
      },
      openUpChildView() {
        window.open(
          this.$router.resolve({
            path: `/activity/childView/${this.applicationID}`,
            query: { startingIndex: this.currentQuestionIndex }
          }).href,
          '_blank'
        );

        if (!this.specialistChannelOpen) {
          this.channel = new BroadcastChannel(`${this.applicationID}`);

          this.channel.addEventListener('message', this.receiveChannelMessage);

          this.specialistChannelOpen = true;
        }
      },
      sendChannelMessage(message) {
        this.channel.postMessage(message);
      },
      scoreQuestion(question, currentScore) {
        this.$forceUpdate()
        question.currentScore = currentScore;
      },
      determineScoreStyleClass(question) {
        if (question.currentScore == null) {
          return '';
        } else if (question.currentScore == question.highest_score_possible) {
          return 'score-greenFull';
        } else if (question.currentScore == 0) {
          return 'score-zero';
        } else {
          return 'score-greenLight';
        }
      },
      formatTime(totalSeconds) {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      },
      formatForNewResolution(elementID) {
        this.$nextTick(() => {
          let currentQuestionInstance = this.fullDataStructure.Questions[this.currentQuestionIndex];
          let [originalWidth, originalHeight] = currentQuestionInstance.child_view_original_screen_resolution.split('x').map(Number);
          let newWidth = document.getElementById(elementID).offsetWidth;
          let newHeight = document.getElementById(elementID).offsetHeight;
          if (newWidth == originalWidth && newHeight == originalHeight) {
            return;
          }

          //[x,y] transform coordinates from original to new resolution
          let xTransform = newWidth / originalWidth;
          let yTransform = newHeight / originalHeight;

          for (let i = 0; i < currentQuestionInstance.Elements.length; i++) {
            currentQuestionInstance.Elements[i].styles.left *= xTransform;
            currentQuestionInstance.Elements[i].styles.top *= yTransform;
            currentQuestionInstance.Elements[i].styles.height *= yTransform;
            currentQuestionInstance.Elements[i].styles.width *= xTransform;
          }

          currentQuestionInstance.child_view_original_screen_resolution = `${newWidth}x${newHeight}`;
        });
      },
      startStopWatch(questionFunctions, stopWatchName, stopWatchElapseTimeName) {
        //questionFunctions is Object
        questionFunctions[stopWatchName] = setInterval(() => {
          questionFunctions[stopWatchElapseTimeName]++;
        }, 1000);
      },
      stopStopWatch(questionFunctions, stopWatchName) {
        //questionFunctions is Object
        clearInterval(questionFunctions[stopWatchName]);
        questionFunctions[stopWatchName] = null;
      },
      resetStopWatch(questionObject, stopWatchName, stopWatchElapseTimeName) {
        let questionFunctions = questionObject;
        questionFunctions[stopWatchElapseTimeName] = 0;
        this.stopStopWatch(questionFunctions, stopWatchName);
        this.startStopWatch(questionFunctions, stopWatchName, stopWatchElapseTimeName);
      },
      startTimer(questionFunctions, timerName, timerElapseTimeName) {
        //questionFunctions is Object
        questionFunctions[timerName] = setInterval(() => {
          let temp = questionFunctions[timerElapseTimeName];
          if (temp - 1 < 0) {
            this.stopTimer(questionFunctions, timerName);
          }
          else {
            questionFunctions[timerElapseTimeName]--;
          }
        }, 1000);
      },
      stopTimer(questionFunctions, timerName) {
        //questionFunctions is Object
        clearInterval(questionFunctions[timerName]);
        questionFunctions[timerName] = null;
      },
      resetTimer(questionObject, timerName, timerElapseTimeName, originalTimeName) {
        let questionFunctions = questionObject;
        questionFunctions[timerElapseTimeName] = questionObject[originalTimeName];
        this.stopTimer(questionFunctions, timerName);
        this.startTimer(questionFunctions, timerName, timerElapseTimeName);
      },
      previewTimingPack(questionObject, setting) {
        let questionFunctions = questionObject;
        //turn on timings
        if (setting) {
          this.startTimer(questionFunctions, 'typicalDurationTimer', 'typicalDurationTimerElapsedTime');
          this.startTimer(questionFunctions, 'timeOutTimer', 'timeOutTimerElapsedTime');
          this.startStopWatch(questionFunctions, 'questionDuration', 'questionDurationTimerElapse');
        }
        else {
          this.stopTimer(questionFunctions, 'typicalDurationTimer');
          this.stopTimer(questionFunctions, 'timeOutTimer');
          this.stopStopWatch(questionFunctions, 'questionDuration');
        }
      },
      previewTimingResetPack(questionObject) {
        this.resetTimer(questionObject, 'typicalDurationTimer', 'typicalDurationTimerElapsedTime', 'typicalDuration');
        this.resetTimer(questionObject, 'timeOutTimer', 'timeOutTimerElapsedTime', 'timeOut');
        this.resetStopWatch(questionObject, 'questionDuration', 'questionDurationTimerElapse');
      },
    },
    beforeDestroy() {
      if (this.channel) {
        this.channel.removeEventListener('message', this.sendChannelMessage);
        this.channel.close();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/_globalSharedVariables';

  $reportOrange: #FF9B00;
	$reportOrangeLight: #eecc9a;
  $greenFull: #ace2c6;
  $greenLight: #D9F2E6;
  $redZero: #FFBCBC;

  $min-sidebar-width: 70px;

  #container {
    width: 100%;
    position: relative;

    #sidebar {
      position: fixed;
      overflow-y: auto;
      height: calc(100dvh - #{globalSharedVariables.$navbar-height});
      padding: 1rem;
      border-right: solid 1px globalSharedVariables.$grey-300;
      z-index: 100;
      background-color: white;

      #min-max-button-container {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 1rem;

        button {
          border-radius: 50rem;
          color: globalSharedVariables.$brand-700;
        }
      }

      &.max-sidebar {
        width: 300px;
      }

      &.min-sidebar {
        width: fit-content;

        > * {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .questionNavBar {
        cursor: pointer;
        padding: .5rem;
        border-radius: 50rem;

        &:hover {
          background-color: globalSharedVariables.$grey-200;
        }
      }

      .selected-question {
        background-color: globalSharedVariables.$brand-50;
        color: globalSharedVariables.$brand-700;
      }
    }

    #main-box {
      background-color: globalSharedVariables.$grey-50;
      height: calc(100dvh - #{globalSharedVariables.$navbar-height});
      margin-left: $min-sidebar-width;

      #question-title-container {
        text-align: center;

        > div {
          color: globalSharedVariables.$brand-700;
          font-weight: 700;
        }
      }

      #test-container {
        display: grid;
        grid-template-columns: 1fr auto;
        grid-template-rows: 1fr auto auto;
        height: 100%;

        > div:nth-child(1) {
          padding: 1rem;
          background-color: white;
          border-radius: 5px;
          border: 1px solid globalSharedVariables.$grey-200;
          box-shadow: 0px 3.6px 5.22px 0px #0000000F;
          height: 100%;

          .border-color-primary {
            width: 100%;
            height: 100%;
            position: relative;

            > div {
              position: absolute;
            }

            .resizable-button-container {
              $local-border-radius: 1rem;

              position: absolute;
              border-radius: $local-border-radius;
              box-shadow: 0 0 5px 5px lightgrey;
              border: solid black 1px;
              user-select: none;
              cursor: pointer;
              
              .placeholder-rect {
                position: absolute;
                top: 0;
                left: 0;
                word-wrap: break-word;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
              }

              img {
                border-radius: $local-border-radius;
              }
            }
          } 
        }

        > div:nth-child(2) {
          padding: .5rem;
          background-color: white;
          border-radius: 5px;
          border: 1px solid globalSharedVariables.$grey-200;
          box-shadow: 0px 3.6px 5.22px 0px #0000000F;
          height: fit-content;
          margin: .5rem;
            
          #timing-container {
            padding: 1rem;

            .grey-800-text {
              color: globalSharedVariables.$grey-800;
              font-weight: 700;
            }

            .grey-700-text {
              color: globalSharedVariables.$grey-700;
            }
          }
        }

        > div:nth-child(3) {
          display: flex;
          justify-content: center;
          align-items: center;
          grid-column: span 2;

          > div {
            display: flex;
            column-gap: 10px;
            grid-column: span 2;
            padding: .5rem;
            margin: .5rem;
            background-color: white;
            border-radius: 5px;
            border: 1px solid globalSharedVariables.$grey-200;
            box-shadow: 0px 3.6px 5.22px 0px #0000000F;
            height: fit-content;
            width: fit-content;
          }

          .answer-card {
            border-radius: 5px;
            border: 1px solid globalSharedVariables.$grey-200;
            color: globalSharedVariables.$grey-700;
            box-shadow: 0px 3.6px 5.22px 0px #0000000F;
            height: fit-content;
            padding: 5px;
            margin: 5px 0;
            width: 110px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            user-select: none;

            .score-number {
              display: inline-flex;
              justify-content: center;
              align-items: center;
              height: 30px;
              width: 30px;
              font-weight: 700;

              &.score-incorrect {
                background-color: globalSharedVariables.$grey-100;
              }

              &.score-correct {
                color: #24B956;
                background-color: #F0FAF3;
              }
            }
          }
        }

        > div:nth-child(4) {
          background-color: white;
          border-top: solid 1px globalSharedVariables.$grey-300;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          grid-column: span 2;

          #icons-container {
            display: flex;

            button {
              margin: 0 10px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center;
              width: 75px;

              svg {
                width: 20px;
                height: 20px;
              }

              small {
                font-size: .7rem;
                line-height: 1.2;
              }
            }
          }
        }
      }

      #finish-box {
        padding: 1rem;

        #final-result-box {
          border: solid 1px #EBEBEB;
          padding: 1rem;
          border-radius: 10px;

          .score-zero {
            background-color: #FFEBEB;
            border: solid 1px #FBD1D1;
          }

          .score-greenFull {
            background-color: #F9FFFB;
            border: solid 1px #BFD9C7;
          }

          .incorrect-box {
            background-color: #DF0404;
            color: white;
            padding: 5px 10px;
            font-weight: 400;
            border-radius: 5px;
          }

          .correct-box {
            background-color: #24B956;
            color: white;
            padding: 5px 10px;
            font-weight: 400;
            border-radius: 5px;
          }
        }

        > div {
          background-color: white;
          border-radius: 5px;
          border: 1px solid globalSharedVariables.$grey-200;
          box-shadow: 0px 3.6px 5.22px 0px #0000000F;
          height: fit-content;
          padding: 1rem;
          margin: 5px 0;
        }

        ul {
          border-radius: 5px;
          list-style: none;
          padding: .8rem;
          color: globalSharedVariables.$grey-800;

          li {
            display: flex;
            justify-content: space-between;
            border: 1px solid globalSharedVariables.$grey-200;
            padding: .5rem;
            border-radius: 5px;
            margin: 5px 0;
            font-weight: 700;
          }
        }
      }

      #intro-container {
        display: flex;
        justify-content: center;

        #intro-box {
          border: solid globalSharedVariables.$grey-200 1px;
          box-shadow: 0px 4px 5.8px 0px #0000000F;
          border-radius: 5px;
          padding: 1rem;

          img {
            width: 170px;
            height: 105px;
            border-radius: 5px;
          }

          #intro-grid {
            display: grid;
            grid-template-columns: auto 1fr;
            column-gap: 2rem;
            row-gap: 1rem;
            margin: 1rem 0;

            > div:nth-child(odd) {
              color: globalSharedVariables.$brand-900;
            }
            > div:nth-child(even) {
              color: globalSharedVariables.$grey-800;
            }

          }
        }
      }
    }
  }
</style>